import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthorizationService } from '@infodata-group/inf-commons';
import { catchError } from 'rxjs/operators';
import { AccountManagerService } from '../service/account-manager.service';
import { Router } from '@angular/router';

@Injectable()
export class AccountOauthInterceptor implements HttpInterceptor {
  private auth = inject(AuthorizationService);
  private accountManager = inject(AccountManagerService);
  private router = inject(Router);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          (error.status === 401 && error.statusText === 'token expired') ||
          (error.status === 408 && error.statusText === "User  doesn't exist")
        ) {
          if (this.auth.hasAutoConnection()) {
            this.auth.autoLogin();
          } else {
            this.auth.logout();
          }
        }
        if (
          req.url !== this.auth.appConfig.loginConfig.loginUrl &&
          error.status === 403
        ) {
          if (error.statusText.indexOf('not authorized to access account')) {
            this.accountManager.clear();
            this.router.navigateByUrl('select-account');
          } else {
            this.auth.logout();
          }
        }
        if (
          error.status === 403 &&
          error.statusText.includes('user id is missing')
        ) {
          this.auth.logout(true);
        }
        return throwError(error);
      }),
    );
  }
}
